import type {SkipToken} from '@reduxjs/toolkit/query'
import {skipToken} from '@reduxjs/toolkit/query'

import {useBranch} from '../../../../hooks/routes'
import {getBranchLocator} from '../../../../rest/locators'
import type {GetAllBuildsApiArg} from '../../../../services/rest'
import {defaultBranch} from '../../../../utils/branchNames'
import type {pipelineHeadFragment$key} from '../hooks/__generated__/pipelineHeadFragment.graphql'
import {usePipelineHeadId} from '../hooks/pipeline'

export function useLastRunLocator(pipelineHeadKey: pipelineHeadFragment$key | null) {
  const headId = usePipelineHeadId(pipelineHeadKey)
  const branch = useBranch()

  return [
    `count:1,buildType:(id:${headId}),state:any`,
    getBranchLocator(branch ?? defaultBranch, true),
  ]
    .filter(Boolean)
    .join(',')
}

export function usePipelineHistoryArg(
  pipelineHeadKey: pipelineHeadFragment$key | null,
): GetAllBuildsApiArg | SkipToken {
  const headId = usePipelineHeadId(pipelineHeadKey)
  const branch = useBranch()

  return headId != null
    ? {
        locator: [
          `defaultFilter:false,buildType:(id:${headId}),state:any,count:20`,
          getBranchLocator(branch, true),
        ]
          .filter(Boolean)
          .join(','),
        fields:
          'build(id,number,state,status,waitReason,startEstimate,finishEstimate' +
          ',canceledInfo,statusText,history,startDate,finishDate,limitedChangesCount($optional)' +
          ',failedToStart,buildType(id),branchName,defaultBranch' +
          ',running-info(percentageComplete,elapsedSeconds,estimatedTotalSeconds,leftSeconds,overtime))',
      }
    : skipToken
}
